let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("xnqy2")).then(() => parcelRequire('J7CId'));